var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _ellipse2, _circle, _line, _line2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgNoLibraryItems = function SvgNoLibraryItems(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 158,
    viewBox: "0 0 289 158",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M51.7262 30.1165C44.8938 28.225 37.1559 28.225 31.2291 32.1725C25.3022 36.1201 22.421 44.7553 26.29 50.6766C30.8175 57.5025 40.8602 57.338 47.9396 61.45C52.3024 63.9995 55.5128 68.276 60.1226 70.4965C67.2843 74.0328 76.01 71.7301 82.9247 67.7825C90.4156 63.506 102.763 47.8804 88.9339 43.4394C83.1717 41.5479 77.4094 41.0545 71.7295 38.5873C64.9794 35.7089 58.7232 32.0081 51.7262 30.1165Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M21.4413 88.5893C35.0237 81.1055 51.2404 80.4475 66.7161 80.4475C82.1919 80.4475 98.2439 80.612 112.567 74.5262C136.522 64.164 149.528 38.7518 167.638 19.9188C174.717 12.5994 184.925 0.0166412 202.047 0.0988814C217.852 0.181122 222.132 6.02017 229.376 15.0666C235.468 22.6327 243.617 53.555 250.12 59.723C260.328 69.4273 272.346 77.3224 280.578 88.836C286.752 97.5535 290.456 108.82 287.163 119.018C284.118 128.476 275.557 135.384 266.255 138.92C248.886 145.5 229.459 142.045 211.596 136.864C193.733 131.765 175.952 124.939 157.43 125.022C138.497 125.104 120.552 132.423 102.936 139.414C85.32 146.404 67.1277 153.312 48.1946 152.654C30.6609 152.079 8.35273 150.269 1.27339 128.558C-4.07728 111.37 8.35273 95.9087 21.4413 88.5893Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 136.7C252.5 139.578 251.429 142.374 249.372 144.348C247.396 146.404 244.597 147.555 241.716 147.638H49.2567C43.3299 147.638 38.5554 142.703 38.5554 138.098V29.3764C38.5554 21.9748 44.7293 17.616 50.6562 17.616L241.798 17.6983C247.725 17.6983 252.5 23.3728 252.5 29.4586V136.7Z",
    fill: "#332F4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3848 143.032C50.0799 143.032 47.8573 142.045 46.2109 140.401C44.5646 138.756 43.6591 136.535 43.6591 134.233V30.6922C43.6591 28.3895 44.5646 26.169 46.2109 24.5242C47.8573 22.8794 50.0799 21.9748 52.3848 21.8925H238.67C240.975 21.8925 243.198 22.8794 244.844 24.5242C246.49 26.169 247.396 28.3895 247.396 30.6922V134.233C247.396 136.535 246.49 138.756 244.844 140.401C243.198 142.045 240.975 142.95 238.67 143.032H52.3848Z",
    fill: "#FFCF01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M172.157 142.95L118.074 21.4813L59.7111 142.95H172.157Z",
    fill: "#F9A20F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228.628 144.595L174.462 21.5636L116.017 144.595H228.628Z",
    fill: "#F9A20F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M239.246 142.786C243.774 142.786 247.478 139.085 247.478 134.562V55.5288L233.155 22.3037H229.862L173.474 142.786H239.246Z",
    fill: "#F9A20F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.452 142.95L60.2873 21.5636L43.4121 59.8052V133.081C43.4121 138.509 47.8573 142.95 53.2903 142.95H114.452Z",
    fill: "#F9A20F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.271 11.1191C240.317 11.1191 242.786 8.65185 242.786 5.60897C242.786 2.56608 240.317 0.098877 237.271 0.098877C234.225 0.098877 231.755 2.56608 231.755 5.60897C231.755 8.65185 234.225 11.1191 237.271 11.1191Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M267.234 59.5585C268.14 57.5848 267.234 55.282 265.259 54.4596C263.283 53.555 260.978 54.4596 260.155 56.4334C259.25 58.4072 260.155 60.7099 262.131 61.5323C264.106 62.3547 266.411 61.4501 267.234 59.5585Z",
    fill: "#F0F0FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M30.5706 74.6907C32.1346 71.3189 30.5706 67.3713 27.1955 65.8088C23.8205 64.2462 19.8692 65.8088 18.3052 69.1806C16.7412 72.5525 18.3052 76.5 21.6802 78.0626C25.0553 79.5429 29.0889 78.0626 30.5706 74.6907Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M30.5706 74.6907C32.1346 71.3189 30.5706 67.3713 27.1955 65.8088C23.8205 64.2462 19.8692 65.8088 18.3052 69.1806C16.7412 72.5525 18.3052 76.5 21.6802 78.0626C25.0553 79.5429 29.0889 78.0626 30.5706 74.6907Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M273.874 47.4903C275.438 44.1184 273.874 40.1709 270.499 38.6083C267.124 37.0458 263.173 38.6083 261.609 41.9802C260.045 45.352 261.609 49.2996 264.984 50.8621C268.359 52.3425 272.393 50.8621 273.874 47.4903Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M53.2079 21.8925H238.012C240.563 21.8925 242.951 22.8794 244.762 24.6887C246.573 26.498 247.56 28.883 247.56 31.4324V91.0565H43.6591V31.4324C43.6591 28.883 44.6469 26.498 46.4579 24.6887C48.2689 22.8794 50.6561 21.8925 53.2079 21.8925Z",
    fill: "url(#paint0_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0862 142.292V153.806H64.7325V153.066H227.228V153.806H228.874V142.292H63.0862Z",
    fill: "#332F4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.792 142.374H63.0862V146.486H228.874V142.374H228.792Z",
    fill: "#305A8A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M258.344 150.598H32.7107C31.8875 150.598 31.229 151.256 31.229 152.079V156.191C31.229 157.013 31.8875 157.671 32.7107 157.671H258.344C259.167 157.671 259.826 157.013 259.826 156.191V152.079C259.826 151.256 259.167 150.598 258.344 150.598Z",
    fill: "#C0D5ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.771 96.3552C139.594 95.2861 140.582 94.4637 141.734 93.888C142.887 93.3123 144.204 92.9834 145.521 92.9834C146.838 92.9834 148.155 93.3123 149.308 93.888C150.46 94.4637 151.53 95.2861 152.271 96.3552",
    stroke: "#2D2D2D",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.273,
    cy: 81.9825,
    rx: 5.30251,
    ry: 5.2975,
    fill: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.983,
    cy: 81.9825,
    rx: 5.30251,
    ry: 5.2975,
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 105,
    r: 20,
    fill: "#332F4B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250.183,
    y1: 97,
    x2: 250.183,
    y2: 113,
    stroke: "white",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 258,
    y1: 105.183,
    x2: 242,
    y2: 105.183,
    stroke: "white",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 145.61,
    y1: 91.0686,
    x2: 145.61,
    y2: 21.9282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5CC"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoLibraryItems, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noLibraryItems.aa8a31fd10dc1da0ed425b0fe3ded638.svg";
export { ForwardRef as ReactComponent };